// extracted by mini-css-extract-plugin
export default {"pibito":"dashboard_pibito__k8ub9","divPibito":"dashboard_divPibito__IAKYC","divInteriorGrafico":"dashboard_divInteriorGrafico__+qRrV","btnStdDev":"dashboard_btnStdDev__kA4Vt"};